import React from 'react';
import img from '../../assets/images/pro-1.svg' 
function FE(){
  return(
    <>
      <img src={img} alt="loading" className="img-responsive img-fluid" />
    </>
  )
}

export default FE;
